import {PaymentMethods} from '../../models/payment-method.model';


export class PaymentMethodUtils {
  static enrichPaymentMethods(methods: PaymentMethods[]): PaymentMethods[] {
    return methods.map(method => {
      let label = '';
      let icon = '';

      switch (method.paymentMode) {
        case 'PAY_NOW':
          label = 'PayNow';
          icon = 'PayNow.png';
          break;
        case 'CHEQUE':
          label = 'Cheque/Cashier’s Order Deposit';
          icon = 'cheque-icon.png';
          break;
        case 'NETS':
          label = 'NETS';
          icon = 'nets.png';
          break;
        case 'CREDIT_CARD':
          label = 'Credit/Debit card';
          icon = 'card.png';
          break;
        default:
          break;
      }

      return {
        ...method,
        label,
        icon
      };
    });
  }
}
